import { Mesh, type Object3D, type Sprite } from "three"
import type { NeighborElevationCollection } from "../../../rx/memo/useNodeNeighborBaseFloorElevationReactiveMap"
import type { RNGConfig } from "../../core/rng/RNGConfig.type"
import { nextNumberRange } from "../../core/rng/index"
import { abs } from "../../core/util/math/Math"
import { VERTICES_PER_TILE } from "../consts"
import getTerrainMesh1Z from "../objects/TerrainMesh1V2/getTerrainMesh1Z"
import isTooClose from "./isTooClose"

const RANGE = (VERTICES_PER_TILE / 32) * 16 * 0.9
const ONE_THIRD = RANGE / 3

const maxTries = 32    // to avoid infinite loops

const minDist = 2

export default function addRandomTileDetailPropPosition(
  parentObj: Object3D,
  item: Mesh | Sprite,
  items: Array<Object3D>,
  rng: RNGConfig,
  baseElevationsCollection: NeighborElevationCollection,
): void {
  let tries = 0, x = 0, y = 0

  let bad = true
  do {
    x = nextNumberRange(-RANGE, RANGE, rng)
    y = nextNumberRange(-RANGE, RANGE, rng)
    bad = (abs(x) < ONE_THIRD && abs(y) < ONE_THIRD) || isTooClose(x, y, items, minDist)
  } while (bad && ++tries < maxTries)

  const { position } = item

  if (!bad) {
    items.push(item)
    parentObj.add(item)
    const z = getTerrainMesh1Z(baseElevationsCollection, x, y)
    position.set(x, y, z)
  }

  return
}
